// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Hwdg5","blue":"Button_blue__jufMf","azure":"Button_azure__VINmB"};